import http from '@/utils/api2'

const moduleUrl = '/erp/cost'

const CostApi = {
    save:(data)=> http.post(`${moduleUrl}/save`, data),
    delete: (ids) => http.post(`${moduleUrl}/delete`, { ids }),
    getInfo: (id) => http.get(`${moduleUrl}/${id}`),
    checkCodeExist: (code) => http.post(`${moduleUrl}/check/code`, { code }),
}
export default CostApi
